import React from "react";
import { MapPin, Phone, Printer, Mail } from "lucide-react";
import "./index.css"; // Importing custom CSS

const OfficeDetails = () => {
  return (
    <div className="off-details-container">
      <h2 className="off-details-heading">OTHERS MANDATORY INFORMATION</h2>

      {/* REGISTERED AGENT & COMPANY INFO */}
      <div className="off-details-info-box">
        <p><strong>REGISTER AGENT:</strong> NIL</p>
        <p><strong>COMPANY RATING:</strong> NIL</p>
        <p><strong>PENAL ACTIONS TAKEN AGAINST FIRM:</strong> NIL</p>
      </div>

      {/* REGISTERED OFFICE DETAILS */}
      <div className="off-details-office-box">
        <h3>REGISTERED OFFICE HEAD</h3>
        <p className="off-details-office-head">MR. MUHAMMAD HAMMAD ARSHAD</p>
        <div className="off-details-details">
          <p><MapPin className="off-details-icon" /> Suite 1101, 11th Floor, Trade Center, I.I Chundrigar Road Karachi</p>
          <p><Phone className="off-details-icon" /> (+92) 21-32622071-9</p>
          <p><Printer className="off-details-icon" /> (+92) 21-32622080</p>
          <p><Mail className="off-details-icon" /> 
            <a href="mailto:info@orbitsecurities.com.pk" className="off-details-email">info@orbitsecurities.com.pk</a>
          </p>
        </div>
      </div>

      {/* BRANCH OFFICE DETAILS */}
      <div className="off-details-office-box">
        <h3>BRANCH OFFICE HEAD</h3>
        <p className="off-details-office-head">MRS. JAMNA DEVI REENA KUMARI</p>
        <div className="off-details-details">
          <p><MapPin className="off-details-icon" /> Suite 92, 2nd Floor, PSX Main Building, I.I Chundrigar Road Karachi</p>
          <p><Phone className="off-details-icon" /> (+92) 21-32470791-4</p>
          <p><Mail className="off-details-icon" /> 
            <a href="mailto:info@orbitsecurities.com.pk" className="off-details-email">info@orbitsecurities.com.pk</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfficeDetails;
